import { Button } from "@/components/elements/Button";
import { AppRoutes } from "@/routes/config";
import { text } from "@/theme/colors";
import { logout } from "@/utils/logout";
import { createUrlWithParams } from "@/utils/url";
import { Paper, Stack, Typography, styled } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

type TRegisterSuccessLocationState = {
  email: string;
};

export const RegisterSuccessForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const email = (location.state as TRegisterSuccessLocationState | null)?.email;

  // Clear any pre-existing session (e.g. the admin who invited this user was
  // still logged in) BEFORE navigating. Navigating via <Link> races the async
  // logout, so /login's withGuest could see the stale token and bounce into the
  // admin area before the session is cleared. Await logout, then navigate to
  // /login?email=... so the just-registered account is pre-filled.
  const handleGoToLogin = async () => {
    await logout();
    navigate(createUrlWithParams(AppRoutes.login, { email }), { replace: true });
  };

  return (
    <Container
      elevation={0}
      sx={{
        width: 464,
        p: 4,
        borderRadius: "12px",
      }}
    >
      <Stack gap={3}>
        <Typography variant="head20Bold" textAlign="center">
          アカウントの登録完了
        </Typography>
        <Typography variant="body14" color={text.secondary} mt={1} mb="12px">
          アカウントの登録が完了しました。
        </Typography>
        <Stack mt="12px">
          <Button size="sm" variant="primary" fullWidth onClick={handleGoToLogin}>
            <Typography variant="body14Semi">ログイン画面へ</Typography>
          </Button>
        </Stack>
      </Stack>
    </Container>
  );
};

const Container = styled(Paper)`
  box-shadow:
    0 4px 4px -1px rgba(12, 12, 13, 0.05),
    0 4px 4px -1px rgba(12, 12, 13, 0.1) !important;
`;
